module.exports = __webpack_public_path__ + "img/banner.1a55186f.svg";